module.exports = "https://web-assets.ifttt.com/packs/media/service-previews/hue-icon-668e1c3a.png";